export default __webpack_public_path__ + "static/media/indexx NFT_o1.7e5329f4.png";